// src/gatsby-theme-apollo/client.js
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client"

const API_URL = "https://admin.jeffpiscine.fr/shop-api"
const AUTH_TOKEN_KEY = "vendure-auth-token"

// Custom fetch that handles auth token in both directions
const customFetch = (uri, options = {}) => {
  // Read token from localStorage at request time
  let token = null
  if (typeof window !== "undefined") {
    token = localStorage.getItem(AUTH_TOKEN_KEY)
  }

  // Add token to headers if available
  if (token) {
    options.headers = {
      ...options.headers,
      "vendure-auth-token": token,
    }
  }

  return fetch(uri, options).then(response => {
    // Capture token from response
    const newToken = response.headers.get("vendure-auth-token")
    if (newToken && typeof window !== "undefined") {
      localStorage.setItem(AUTH_TOKEN_KEY, newToken)
    }
    return response
  })
}

const httpLink = createHttpLink({
  uri: API_URL,
  credentials: "include",
  fetch: customFetch,
})

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: httpLink,
})

export default client
